export default "__VITE_ASSET__DBKJxqhY__"